import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    getRowRegistrationDictKey,
    RowRegistrationStatus,
} from 'app/shared/features/map-row-selector/models';
import { registrationsFeatureKey, RegistrationState } from 'app/state/registrations/registrations.reducer';
import { getRowSelectionByRowNumber } from 'app/state/row-selection/row-selection.selectors';

export const selectRegistrationsState = createFeatureSelector<RegistrationState>(registrationsFeatureKey);

export const selectCachedRegistrations = createSelector(
    selectRegistrationsState,
    (state) => state.cachedRegistrations,
);

export const selectCachedRegistrationsAsArray = createSelector(
    selectCachedRegistrations,
    (cachedRegistrations) => Object.values(cachedRegistrations),
);
export const selectRegistrationError = createSelector(selectRegistrationsState, (state) =>
    state.sendProgress.error ? { errorMessage: state.sendProgress.errorMessage } : undefined,
);

export const selectServerRowRegistrations = createSelector(
    selectRegistrationsState,
    (state) => state.serverRowRegistrations,
);

export const selectRowRegistrationStatus = ({
    activityNumber,
    rowNumber,
}: {
    activityNumber: number;
    rowNumber: number;
}) =>
    createSelector(
        selectCachedRegistrationsAsArray,
        selectServerRowRegistrations,
        (cachedRegistrations, serverRowRegistrations): RowRegistrationStatus | undefined => {
            const cachedRowRegistration = cachedRegistrations
                .filter((registration) => registration.activityNumber === activityNumber)
                .flatMap((registration) => registration.rowRegistrations)
                .find((rowRegistration) => rowRegistration.rowNumber === rowNumber);
            return (
                cachedRowRegistration?.registrationStatus ??
                serverRowRegistrations[
                    getRowRegistrationDictKey({
                        activityNumber,
                        rowNumber,
                    })
                ]
            );
        },
    );

export const selectPreliminaryRowRegistrationStatus = ({
    activityNumber,
    rowNumber,
}: {
    activityNumber: number;
    rowNumber: number;
}) =>
    createSelector(
        getRowSelectionByRowNumber(rowNumber),
        selectRowRegistrationStatus({ activityNumber, rowNumber }),
        (currentRowSelection, currentRowRegistrationStatus) => {
            return currentRowSelection?.registrationStatus ?? currentRowRegistrationStatus;
        },
    );
